<template>
  <div class="flex bg-g0-dark mt-2 w-fit">
    <div
      class="bg-g0-dark py-1 px-2 hover:bg-flyingeye-light cursor-pointer"
      :class="{ '!bg-flyingeye': config.camera.status.camera_mode == 0 }"
      @click.stop.prevent="changeCameraMode('photo')"
    >
      <SVG name="photo" css="w-[17px] fill-current aspect-square"></SVG>
    </div>
    <div
      class="bg-g0-dark py-1 px-2 hover:bg-flyingeye-light cursor-pointer"
      :class="{ '!bg-flyingeye': config.camera.status.camera_mode == 1 }"
      @click.stop.prevent="changeCameraMode('camera')"
    >
      <SVG name="camera" css="w-[17px] fill-current aspect-square"></SVG>
    </div>
  </div>
</template>
<script>
import API from "@/utils/API";
import SVG from "@/partials/SVG.vue";
export default {
  name: "Mode_Switch",
  components: {
    SVG,
  },
  props: {
    config: Object,
    video: Object,
  },
  setup() {
    return {};
  },

  mounted() {},

  methods: {
    async changeCameraMode(type) {
      let idMode = type === "photo" ? 0 : 1;

      let data = await API.put(`cameramodeswitch`, {
        DevId: this.config.deviceFamilly.this_dev_id,
        CamId: this.config.camera.payload_index,
        Mode: idMode,
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: "Mode " + type,
      };
    },
  },
};
</script>
